import { useAuthStore } from "../functions/AuthState";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const Dashboard = () => {
  const { logout, loading, isAuthenticated } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login");
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="h-screen flex">
      {/* Sidebar */}
      <aside className="w-64 bg-navyBlue text-white p-5 flex flex-col">
        <h2 className="text-xl font-bold mb-6">Menú</h2>
        <nav>
          <ul>
            <li className="mb-4"><a href="#" className="hover:underline">Inicio</a></li>
            <li className="mb-4"><a href="#" className="hover:underline">Perfil</a></li>
            <li className="mb-4"><a href="#" className="hover:underline">Ajustes</a></li>
          </ul>
        </nav>
        <button
          onClick={logout}
          className="mt-auto bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition duration-300"
          disabled={loading}
        >
          {loading ? "Cerrando sesión..." : "Cerrar sesión"}
        </button>
      </aside>

      {/* Main Content */}
      <main className="flex-1 p-8 bg-gray-100 flex flex-col items-center justify-center">
        <h1 className="text-3xl font-bold mb-6">Bienvenido al Dashboard</h1>
        <p className="text-gray-600">Administra tu cuenta y configura tus preferencias aquí.</p>
      </main>
    </div>
  );
};
